import { useContext, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Label from '../../../components/form/Label'
import catchError from '../../../components/global/CatchError'
import Loader from '../../../components/global/Loader'
import Title from '../../../components/global/Title'
import { sweetAlertSuccess } from '../../../components/sweetalert/Alert'
import { StyledButtonLink } from '../../../components/table/Td'
import UserContext from '../../../context/UserContext'
import { useLangSelected } from '../../../hooks/useLangSelected'
import { useVerifyAdminToken } from '../../../hooks/useVerifyAdminToken'
import apiClient from '../../../services/apiClient'
import { StyledButton } from '../Login'
import { AdminContainer, TitleWrapper } from '../users/AdminUsers'
import { AdminForm } from '../users/AdminUsersForm'

const AdminBadnetTournamentForm = () => {
    const user = useContext(UserContext)
    const location = useLocation()
    const params = useParams()

    const verifyToken = useVerifyAdminToken()
    const lng = useLangSelected()
    const [currentLang, setCurrentLang] = useState(lng)

    const navigate = useNavigate()
    const BACK_LINK = `/${lng}/bva-admin/tournois-badnet`

    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [categories, setCategories] = useState('')
    const [promoted, setPromoted] = useState(false)
    const [classifications, setClassifications] = useState('')
    const [url, setUrl] = useState('')
    const [deadline, setDeadline] = useState('')
    const [place, setPlace] = useState('')
    const [participants, setParticipants] = useState('')
    const [date, setDate] = useState('')
    const [lat, setLat] = useState('')
    const [lngCoord, setLngCoord] = useState('')
    const [distance, setDistance] = useState('')
    const [isComing, setIsComing] = useState(true)
    const [helloassoUrl, setHelloassoUrl] = useState('')

    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        verifyToken()
        if (isLoading) {
            setCurrentLang(lng)
            apiClient
                .get(`/badnet/${params.id}`)
                .then((res) => {
                    const data = res.data.data
                    setName(data.name || '')
                    setTitle(data.title || '')
                    setCategories(data.categories || '')
                    setPromoted(data.promoted || false)
                    setClassifications(data.classifications || '')
                    setUrl(data.url || '')
                    setDeadline(data.deadline || '')
                    setPlace(data.place || '')
                    setParticipants(data.participants || '')
                    setDate(data.date || '')
                    setLat(data.lat ? data.lat.toString() : '')
                    setLngCoord(data.lng ? data.lng.toString() : '')
                    setDistance(data.distance || '')
                    setIsComing(data.isComing !== undefined ? data.isComing : true)
                    setHelloassoUrl(data.helloassoUrl || '')
                    setIsLoading(false)
                })
                .catch((err) => {
                    catchError(err.response.data)
                    setIsLoading(false)
                })
        }
    }, [isLoading, params.id, lng])

    if (isLoading) return <Loader />

    const isValidate = name.length > 0 && title.length > 0 && place.length > 0 && date.length > 0

    const submit = () => {
        verifyToken()
        const data = {
            name,
            title,
            categories,
            promoted,
            classifications,
            url,
            deadline,
            place,
            participants,
            date,
            lat: lat ? parseFloat(lat) : null,
            lng: lngCoord ? parseFloat(lngCoord) : null,
            distance,
            isComing,
            helloassoUrl,
        }

        apiClient
            .patch(`/badnet/${params.id}`, data)
            .then(() =>
                sweetAlertSuccess(`Le tournoi a bien été modifié.`).then(() => {
                    navigate(BACK_LINK)
                }),
            )
            .catch((err) => {
                catchError(err.response.data)
            })
    }

    return (
        <>
            <TitleWrapper>
                <Title>Modifier un tournoi</Title>
                <StyledButtonLink to={BACK_LINK} className="btn btn-primary mb-2">
                    Retour
                </StyledButtonLink>
            </TitleWrapper>
            <AdminContainer>
                <AdminForm>
                    <Form.Group className="mb-3">
                        <Label>Nom du tournoi *</Label>
                        <Form.Control
                            type="text"
                            placeholder="Nom du tournoi"
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Titre *</Label>
                        <Form.Control
                            type="text"
                            placeholder="Titre du tournoi"
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Catégories</Label>
                        <Form.Control
                            type="text"
                            placeholder="Catégories (ex: Simple, Double)"
                            onChange={(e) => setCategories(e.target.value)}
                            value={categories}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Classements</Label>
                        <Form.Control
                            type="text"
                            placeholder="Classements (ex: Série A, Série B)"
                            onChange={(e) => setClassifications(e.target.value)}
                            value={classifications}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Lieu *</Label>
                        <Form.Control
                            type="text"
                            placeholder="Lieu du tournoi"
                            onChange={(e) => setPlace(e.target.value)}
                            value={place}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Date *</Label>
                        <Form.Control
                            type="text"
                            placeholder="Date (ex: 31 mai 2026)"
                            onChange={(e) => setDate(e.target.value)}
                            value={date}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Date limite d'inscription</Label>
                        <Form.Control
                            type="text"
                            placeholder="Date limite (ex: 15 mai 2026)"
                            onChange={(e) => setDeadline(e.target.value)}
                            value={deadline}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Participants (format: 15/30)</Label>
                        <Form.Control
                            type="text"
                            placeholder="15/30"
                            onChange={(e) => setParticipants(e.target.value)}
                            value={participants}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>URL BadNet</Label>
                        <Form.Control
                            type="text"
                            placeholder="URL BadNet"
                            onChange={(e) => setUrl(e.target.value)}
                            value={url}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>URL HelloAsso</Label>
                        <Form.Control
                            type="text"
                            placeholder="URL HelloAsso"
                            onChange={(e) => setHelloassoUrl(e.target.value)}
                            value={helloassoUrl}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Latitude</Label>
                        <Form.Control
                            type="number"
                            placeholder="Latitude"
                            onChange={(e) => setLat(e.target.value)}
                            value={lat}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Longitude</Label>
                        <Form.Control
                            type="number"
                            placeholder="Longitude"
                            onChange={(e) => setLngCoord(e.target.value)}
                            value={lngCoord}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Label>Distance</Label>
                        <Form.Control
                            type="text"
                            placeholder="Distance (ex: 50 km)"
                            onChange={(e) => setDistance(e.target.value)}
                            value={distance}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Tournoi à venir"
                            checked={isComing}
                            onChange={(e) => setIsComing(e.target.checked)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Promu"
                            checked={promoted}
                            onChange={(e) => setPromoted(e.target.checked)}
                        />
                    </Form.Group>
                    <StyledButton variant="primary" type="button" disabled={!isValidate} onClick={submit}>
                        Modifier
                    </StyledButton>
                </AdminForm>
            </AdminContainer>
        </>
    )
}

export default AdminBadnetTournamentForm
